<template>
  <el-config-provider :locale="$i18n.locale === 'zh-cn' ? zhCn : enUs">
    <n-config-provider
      :theme-overrides="themeOverrides"
      :locale="$i18n.locale === 'zh-cn' ? zh : en"
      :date-locale="$i18n.locale === 'zh-cn' ? dateZhCN : dateEnUS"
    >
      <div class="h-screen">
        <router-view></router-view>
      </div>
      <div
        class="cursor-pointer fixed w-12 text-center right-[72px] top-[15px]"
        @click="changeLang"
      >
        <svg-icon
          name="lang-zh-cn"
          v-if="locale === 'en-us'"
          width="48"
          height="21"
        />
        <svg-icon name="lang-en-us" v-else width="48" height="21" />
      </div>
    </n-config-provider>
  </el-config-provider>
</template>

<script setup lang="ts">
import {
  type GlobalThemeOverrides,
  zhCN as zh,
  dateZhCN,
  enUS as en,
  dateEnUS
} from 'naive-ui'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import enUs from 'element-plus/dist/locale/en.mjs'
import { useDialogStore } from './store'

const primaryColor = '#e32832'
const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColorHover: primaryColor,
    primaryColor: primaryColor,
    lineHeight: '1.5',
    placeholderColor: '#BDC3CE',
    textColor1: '#161717',
    textColor2: '#161717'
  },
  Tabs: {
    tabFontSizeLarge: '18px',
    tabFontSizeMedium: '16px',
    tabPaddingLargeBar: '6px 0',
    tabPaddingMediumBar: '11px 0',
    panePaddingLarge: '20px 0 0',
    tabGapMediumBar: '60px',
    panePaddingMedium: '22px 0 0'
  },
  Form: {
    labelTextColor: '#6C6D70',
    labelFontSizeTopMedium: '12px',
    labelFontWeight: '500',
    feedbackHeightMedium: '20px'
  },
  Input: {
    paddingMedium: '0 16px',
    textColor: '#161717'
  },
  Checkbox: {
    fontSizeSmall: '12px',
    textColor: '#404040'
  },
  Avatar: {
    heightMedium: '22px'
  },
  Collapse: {
    fontSize: '13px',
    titleFontSize: '13px',
    titleTextColor: 'inherit'
  },
  Button: {
    paddingSmall: '3px 16px'
  },
  DataTable: {
    thTextColor: '#4F5258',
    tdTextColor: '#4F5258',
    thPaddingMedium: '14px 13px',
    tdPaddingMedium: '14px 13px'
  },
  Tooltip: {
    padding: '5px 8px',
    fontSize: '13px'
  },
  Steps: {
    indicatorSizeSmall: '20px'
  }
}

const { locale } = useI18n()
const changeLang = () => {
  locale.value = locale.value === 'en-us' ? 'zh-cn' : 'en-us'
  localStorage.setItem('lang', locale.value)
}

const dialogStore = useDialogStore()
onMounted(() => {
  const pathname = window.location.pathname
  dialogStore.debug = pathname.includes('debug')
})
</script>

<style scoped></style>
